import React from 'react'
import {assignInlineVars} from '@vanilla-extract/dynamic'
import {LinkGroupContent} from '../../types/cms'
import {SlotComponent} from '../../types/ui'
import {Box, Flex, Stack, Text} from '../../vanilla'
import {ChevronRightIcon} from '../icons'
import {Link} from '../link'
import {Sprinkles} from '../../vanilla/sprinkles.css'
import {linkGroupHeadingBackground, headingBgMobileVar, headingBgDesktopVar} from './styles.css'
import {useSelectContentTracking} from '../../analytics/select-content-tracking'

export const ContentLinkGroup: SlotComponent<LinkGroupContent> = ({content}) => {
  const {heading, headingAlignment, anchorID, headingBackground, linkItems} = content
  const textAlign = (headingAlignment || 'left').toLowerCase() as Sprinkles['textAlign']
  const sendSelectContentData = useSelectContentTracking()

  if (!content || !linkItems?.length) {
    return null
  }

  return (
    <Stack spacing="0px" id={anchorID ?? undefined}>
      {heading && (
        <Stack
          spacing="16px"
          paddingBottom="16px"
          paddingY="16px"
          paddingLeft={['24px', '0px']}
          className={linkGroupHeadingBackground}
          style={assignInlineVars({
            [headingBgMobileVar]: headingBackground?.mobile?.color || 'transparent',
            [headingBgDesktopVar]: headingBackground?.desktop?.color || 'transparent',
          })}
        >
          <Text 
            variant="heading10" 
            textAlign={textAlign}
            lineHeight="none"
          >
            {heading}
          </Text>
        </Stack>
      )}

      <Box
        display={['block', 'grid']}
        style={{gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '20px'}}
      >
        {linkItems.map((item, index) => (
          <Link
            key={`${content?._meta?.deliveryId}-link-${index}`}
            href={item.url}
            textDecoration="none"
            display="block"
            disableExternalLinkIcon
            onClickCapture={() =>
              sendSelectContentData(content, {
                contentName: item.label,
                contentUrl: item.url,
                contentId: content?._meta?.name ?? heading
              })
            }
          >
            <Flex
              backgroundColor="white"
              justifyContent="space-between"
              alignItems="center"
              paddingY="16px"
              paddingX="28px"
              gap="10px"
              borderBottom={index < linkItems.length - 1 ? ['1px', 'none'] : 'none'}
              borderColor="gray200"
              height={['auto', 'full']}
            >
              <Text variant="unstyled" fontWeight="normal" fontSize="md">
                {item.label}
              </Text>
              <Box>
                <ChevronRightIcon boxSize="16px" color="gray800" />
              </Box>
            </Flex>
          </Link>
        ))}
      </Box>
    </Stack>
  )
}